import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import './styles.pcss';
import Logo from './images/dsp-logo.svg';
import BackgroundImage from './images/dsp-career-bg.jpg';

export default class OpeningsDirectoryDspLayout extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    privacyPolicyEnabled: PropTypes.bool,
    privacyPolicyUrl: PropTypes.string,
    privacyPolicyLinkLabel: PropTypes.string,
    termsOfServiceLinkLabel: PropTypes.string,
  }

  static defaultProps = {
    privacyPolicyEnabled: false,
    privacyPolicyUrl: null,
    privacyPolicyLinkLabel: null,
    termsOfServiceLinkLabel: null,
  }

  render() {
    const {
      privacyPolicyEnabled,
      privacyPolicyUrl,
      privacyPolicyLinkLabel,
      termsOfServiceLinkLabel,
    } = this.props;

    return (
      <div className="openings-directory-layout">

        <div className="dsp-nav">
          <img
            alt="dsp-logo"
            src={Logo}
            className="dsp-nav__logo"
          />
        </div>

        <div className="dsp-header">
          <div className="dsp-header__text-wrapper">
            <h1 className="dsp-header__title">Deliver to your<br />community</h1>
          </div>
          <img
            alt="dsp-background"
            src={BackgroundImage}
            className="dsp-background-img"
          />
        </div>

        <div className="dsp-body">
          {this.props.children}
        </div>

        <div className="dsp-footer">
          <div className="dsp-footer__label">
            <img
              alt="dsp-logo"
              src={Logo}
              className="dsp-footer__label-logo"
            />
            <div className="dsp-footer__label-text">©2021, Amazon.com, Inc. or its affiliates</div>
          </div>
        </div>

        <div className="dsp-footer__powered-by">
          <span className="dsp-footer__powered-by-text">Powered by Fountain</span>
          {privacyPolicyEnabled && privacyPolicyUrl && (
            <Fragment>
              <span className="dsp-footer__sep" aria-hidden="true">|</span>
              <a className="dsp-footer__link" href={`${privacyPolicyUrl}#privacy-policy`}>{privacyPolicyLinkLabel}</a>
              <span className="dsp-footer__sep" aria-hidden="true">|</span>
              <a className="dsp-footer__link" href={`${privacyPolicyUrl}#terms-of-service`}>{termsOfServiceLinkLabel}</a>
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}
